import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { formatCentsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { Button } from "../../../components/Button";
import { DialogFooter } from "../../../components/DialogFooter";
import { InstantPayIndicator } from "../../../WorkerShifts/components/InstantPayIndicator";

interface ShiftBundleBottomSheetFooterProps {
  requiredShiftCount: number;
  totalShiftCount: number;
  totalPayInMinorUnits: number | undefined;
  isInstantPay: boolean;
  isBookable: boolean;
  onSelectShifts: () => void;
}

function getButtonText(
  isBookable: boolean,
  requiredShiftCount: number,
  totalShiftCount: number
): string {
  if (!isBookable) {
    return "Can't book";
  }

  if (requiredShiftCount === totalShiftCount) {
    return "Book";
  }

  return "Select shifts";
}

export function ShiftBundleBottomSheetFooter(props: ShiftBundleBottomSheetFooterProps) {
  const {
    requiredShiftCount,
    totalShiftCount,
    totalPayInMinorUnits,
    isInstantPay,
    isBookable,
    onSelectShifts,
  } = props;

  return (
    <DialogFooter withShadow orientation="vertical">
      <Stack direction="row" sx={{ width: "100%", justifyContent: "space-between" }}>
        <Stack spacing={3} sx={{ paddingLeft: 5 }}>
          {isDefined(totalPayInMinorUnits) && (
            <Text semibold variant="h4">
              {requiredShiftCount !== totalShiftCount && (
                <Text inline variant="h4" sx={(theme) => ({ color: theme.palette.text.primary })}>
                  Up to{" "}
                </Text>
              )}
              {formatCentsAsUsd(totalPayInMinorUnits)}
            </Text>
          )}
          {isInstantPay && <InstantPayIndicator />}
        </Stack>

        <Button disabled={!isBookable} variant="contained" size="large" onClick={onSelectShifts}>
          {getButtonText(isBookable, requiredShiftCount, totalShiftCount)}
        </Button>
      </Stack>
    </DialogFooter>
  );
}
